import React, { FunctionComponent } from "react";

import { TirePartItem } from "../../../queries/useSearchTiresByVehicle";
import { Section } from "../../../ui/Section/Section";
import { Warranty as WarrantyText } from "../../Tires/Common/Warranty";
import { SectionHeading } from "../Common/SectionHeading";

type WarrantyProps = {
  part: TirePartItem | null;
};

export const Warranty: FunctionComponent<WarrantyProps> = ({ part }) => {
  return (
    <Section>
      <SectionHeading translation="searchResults.warranty" />
      <WarrantyText className="max-h-24 overflow-y-auto" part={part} />
    </Section>
  );
};
